import React from 'react';
import logoImage from '../../assets/images/Logo_bonepeye_nouveau.png';

const Logo = ({ size = 'medium', className = '' }) => {
  const sizeClasses = {
    small: 'h-12 w-12',
    medium: 'h-20 w-20',
    large: 'h-32 w-32',
    xlarge: 'h-48 w-48'
  };

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <img 
        src={logoImage} 
        alt="Logo Bon'Epey'a Ntoko" 
        className={`${sizeClasses[size]} object-contain`}
      />
    </div>
  );
};

export default Logo;
